import { render, staticRenderFns } from "./SalesTotalizers.vue?vue&type=template&id=247d8713"
import script from "./SalesTotalizers.vue?vue&type=script&lang=js"
export * from "./SalesTotalizers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports